var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E4E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.765 6.23492C14.5761 3.04594 9.409 3.04081 6.22618 6.22362C3.04132 9.40951 3.0444 14.5745 6.23543 17.7635C9.4244 20.9525 14.5925 20.9566 17.7743 17.7738C20.9581 14.591 20.955 9.42389 17.765 6.23492ZM13.6538 15.4311L11.9201 13.6974L10.1865 15.4311C9.47883 16.1387 8.94683 16.7549 8.10259 15.9117C7.26042 15.0685 7.87356 14.5365 8.58428 13.8279L10.3179 12.0952L8.58428 10.3616C7.87562 9.65395 7.26042 9.12194 8.10259 8.27771C8.94683 7.43553 9.47883 8.05073 10.1865 8.75939L11.9201 10.491L13.6538 8.75939C14.3624 8.05176 14.8914 7.4345 15.7356 8.27771C16.5798 9.12194 15.9646 9.65395 15.256 10.3616L13.5223 12.0942L15.256 13.8268C15.9636 14.5365 16.5798 15.0685 15.7356 15.9117C14.8934 16.7549 14.3624 16.1387 13.6538 15.4311Z",
    fill: "#EC4C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanError);
export default __webpack_public_path__ + "static/media/canError.44b91ad8afa5de63fece65235fb2f6e9.svg";
export { ForwardRef as ReactComponent };